<template>
    <div class="home-container"
         :style="homeStyle"
         v-if="attendee">
        <vue-title :title="attendee.Show.Name" :brand="true"></vue-title>
        <div v-if="attendee.Show.Sections" class="home-link-container"> 
            <template v-for="(section,i) in attendee.Show.Sections"
                      :key="section.Code || i">
                <live-sessions-widget v-if="shouldShowLiveSessionsWidget(section)"
                                      :section="section" />
                <home-item @interacted="doNavigate(getRouterLink(section,i))"
                           v-else-if="shouldShowHomeSection(section)"
                           :section="section">
                </home-item>

            </template>
        </div>
    </div>
</template>
<script>
import Token from './authentication/token'
import Common from './common'
import LiveSessionsWidget from './live.sessions.widget.vue'

import { AppState } from './appstate';

export default {
    props: [
    ],

    mixins: [
        Token,
        Common
    ],

    components: {
        LiveSessionsWidget
    },

    computed: {
        attendee() {
            return AppState.attendee;
        },

        homeStyle() {
            let theme = AppState.attendee.Show.Theme;
            if(!theme) {
                return null;
            }

            if(theme.HomeBackgrounds && theme.HomeBackgrounds.length > 0) {
                
                let randomIndex = Math.floor(Math.random() * theme.HomeBackgrounds.length);

                return `background-image: url('${theme.HomeBackgrounds[randomIndex]}');'`;
            }
        }
    },

    methods: {
        isLiveSessionsWidget(section) {
            return section.SectionTypeCode == 'AppLink'
                && section.AppLinkTypeCode == 'LiveSessions';
        },

        isMenuOnlySection(section) {
            return section.Size && section.Size.startsWith('menuonly');
        },

        shouldShowHomeSection(section) {
            return !this.isMenuOnlySection(section)
                && this.attendeeAllowedToViewSection(section);
        },

        shouldShowLiveSessionsWidget(section) {
            return this.isLiveSessionsWidget(section)
                && this.shouldShowHomeSection(section);
        }
    },

    data() {
        return {
        }
    },

    mounted: function() {
        this.postAnalytics(
            AppState.attendee.Code, 
            'LandingPage',
            null,
            null, 
            AppState.attendee.Show.Code);
    }
}
</script>
